import { jsx } from "react/jsx-runtime";
import { Modal, Text } from "@nxt-costco-com/forge-components";
import { EXTERNAL_LINK_MODAL_ELEMENT_ID } from "./constants.js";
const ExternalLinkModal = ({
  href,
  isOpen,
  setOpen,
  onCloseHandler,
  translations
}) => {
  const visitExternalLink = () => {
    if (href && typeof href === "string") {
      window.open(href, "_blank");
      setOpen(false);
    }
  };
  const primaryButtonText = (translations == null ? void 0 : translations.primaryButtonContent) || "Visit External Link";
  const secondaryButtonText = (translations == null ? void 0 : translations.secondaryButtonContent) || "Cancel";
  return /* @__PURE__ */ jsx(
    Modal,
    {
      buttons: [
        {
          action: visitExternalLink,
          text: primaryButtonText
        },
        {
          action: onCloseHandler,
          text: secondaryButtonText
        }
      ],
      closeButtonAriaLabel: (translations == null ? void 0 : translations.closeButtonAriaLabel) || "Close",
      hideBackdrop: false,
      id: EXTERNAL_LINK_MODAL_ELEMENT_ID,
      isOpen,
      modalTitle: (translations == null ? void 0 : translations.titleContent) || "Visit External Link",
      onClose: onCloseHandler,
      children: /* @__PURE__ */ jsx(Text, { children: (translations == null ? void 0 : translations.bodyContent) || "You are about to visit an external link. Do you want to continue?" })
    }
  );
};
export {
  ExternalLinkModal
};
